export default __webpack_public_path__ + "static/media/Avatar-16.e9da467c.png";